module.exports = __webpack_public_path__ + "img/websiteDisplay.e1aba2de.webp";